var _ellipse, _circle, _ellipse2, _ellipse3, _circle2, _ellipse4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.00001,
    cy: 1.58695,
    rx: 1.08695,
    ry: 1.08695,
    fill: "#1D2933"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.00004,
    cy: 5.49906,
    r: 1.08695,
    fill: "#1D2933"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.00004,
    cy: 9.41312,
    rx: 1.08695,
    ry: 1.08695,
    fill: "#1D2933"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99998,
    cy: 1.58695,
    rx: 1.08695,
    ry: 1.08695,
    fill: "#1D2933"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 5.49906,
    r: 1.08695,
    fill: "#1D2933"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 9.41312,
    rx: 1.08695,
    ry: 1.08695,
    fill: "#1D2933"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag-icon.e920ad50c780207c8a9ddcd9b5bce305.svg";
export { ForwardRef as ReactComponent };